import {Component, Input} from '@angular/core';
import {PatientDataProvider} from '../../../providers/patient-data/patient-data';
import {GeoPlace} from '../../../interfaces/geo-place-data';

@Component({
  selector: 'page-gps',
  templateUrl: 'gps.html',
  styleUrls: ['./gps.scss']
})
export class GpsPage {
  @Input() showHeader = true;

  constructor(public patientDataProvider: PatientDataProvider) {
  }

  /**
   * Update GeoData from Patient
   *
   * @param updateData:GeoPlace
   *
   *
   */
  updateGeoData(updateData: GeoPlace) {
    this.patientDataProvider.activePatientData.geoPlace = updateData;
    this.patientDataProvider.update(this.patientDataProvider.activePatientData).subscribe((data: any) => {
      this.patientDataProvider.activePatientData._rev = data.data.data.rev;
    });
  }

}
